<template>

  <!-- Home View -->
  <div class="home-view">

    <!-- Main Content -->
    <div class="aliceblue fira flex-vertical p-center">
      <p class="large">Welcome to Acumapify</p>
      <p>Use one of the buttons on the left to get started!</p>
    </div>

    <!-- User Panel -->
    <UserPanel :user="userStore.user" />

  </div>
</template>

<script lang="ts" setup>
import UserPanel from '@/components/UserPanel.vue';
import { useUserStore } from '@/services/auth';

const userStore = useUserStore();
</script>

<style>
.home-view {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
</style>
